import cookie from 'js-cookie';

import { DimensionKeys } from '../google-analytics';
import isZocdocBrand from '../../utils/isZocdocBrand';
import isUserExperienceTest from '../../utils/isUserExperienceTest';

const getBranding = () => ({
    dimension: DimensionKeys.Brand,
    value: '1Z',
});

const getProduct = ({ theme }) => ({
    dimension: DimensionKeys.Product,
    value: isZocdocBrand(theme.directoryId)
        ? 'Core'
        : 'Whitelabel',
});

const getSessionId = () => {
    const sessionCookie = cookie.get('bsid');

    return {
        dimension: DimensionKeys.SessionID,
        value: sessionCookie ? sessionCookie.split('_')[0] : null,
    };
};

const getZlogsCategory = ({ pageCategory }, state) => ({
    dimension: DimensionKeys.ZlogPageType,
    value: pageCategory(state),
});

const getZocmonPageType = ({ pageType }, state) => ({
    dimension: DimensionKeys.PageTypeZocMon,
    value: pageType(state),
});

const getUserType = () => ({
    dimension: DimensionKeys.UserLoginStatus,
    value: 'NoLogin',
});

const getWhiteLabel = theme => {
    const value = theme.analyticsName || '(unknown)';

    return {
        dimension: DimensionKeys.WhiteLabel,
        value,
    };
};

const getUserExperienceTest = () => ({
    dimension: DimensionKeys.UserExperienceTest,
    value: isUserExperienceTest(),
});

const emptyCustomDimensions = () => [];

export default function getCustomDimensions({
    analytics,
    state,
    theme,
}) {
    const { pageSpecificCustomDimensions = emptyCustomDimensions } = analytics;
    const customDimensions = pageSpecificCustomDimensions(state);
    customDimensions.push(getBranding());
    customDimensions.push(getProduct({ theme }));
    customDimensions.push(getZlogsCategory(analytics, state));
    customDimensions.push(getZocmonPageType(analytics, state));
    customDimensions.push(getUserType());
    customDimensions.push(getUserExperienceTest());
    customDimensions.push(getSessionId());

    if (!isZocdocBrand(theme.directoryId)) {
        customDimensions.push(getWhiteLabel(theme));
    }

    return customDimensions;
}
